import {
  Component,
  OnInit,
  Input,
  ViewChild,
  TemplateRef
} from '@angular/core';

@Component({
  selector: 'app-datatable-footer',
  template: `<ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize" let-selectedCount="selectedCount"
  let-curPage="curPage" let-offset="offset">
  <div class="page-count" *ngIf="rowCount>0" [innerHTML]="'当前 '+((offset||0) * pageSize + 1)+' - '+((offset+1) * pageSize > rowCount?rowCount : ((offset+1)||1) * pageSize)+' / '+rowCount+' 行'">
  </div>
  <app-datatable-pager *ngIf="rowCount>0" [pageSizeArray]="pageSizeArray" [pagerPreviousIcon]="'fa fa-step-backward'" [pagerNextIcon]="'fa fa-step-forward'"
    [pagerLeftArrowIcon]="'fa fa-angle-left'" [pagerRightArrowIcon]="'fa fa-angle-right'" [page]="curPage" [size]="pageSize"
    [datatable]="datatable" [count]="rowCount" (change)="datatable.onFooterPage($event)" class="datatable-pager">
  </app-datatable-pager>
</ng-template>`
})
export class DatatableFooterComponent implements OnInit {
  @ViewChild(TemplateRef)
  set template(val: TemplateRef<any>) {
    this._template = val;
    this.update();
  }
  get template(): TemplateRef<any> {
    return this._template;
  }

  @Input()
  set datatable(val: any) {
    this._datatable = val;
    this.update();
  }
  get datatable(): any {
    return this._datatable;
  }

  @Input() pageSizeArray?: any[] = [10, 20, 30, 40, 50];

  private _template: any;
  private _datatable: any;

  constructor() { }

  ngOnInit() { }

  private update(): void {
    if (
      this._datatable &&
      this._template &&
      (!this._datatable.footer || !this._datatable.footer.template)
    ) {
      if (this._datatable.footer) {
        this._datatable.footer.template = this._template;
      } else {
        this._datatable.footer = {
          footerHeight: this._datatable.footerHeight,
          totalMessage: this._datatable.messages.totalMessage,
          selectedMessage: this._datatable.messages.selectedMessage,
          pagerLeftArrowIcon: '',
          pagerRightArrowIcon: '',
          pagerPreviousIcon: '',
          pagerNextIcon: '',
          template: this._template
        };
      }
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/datatable-footer/datatable-footer.component.ts